import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, Grid, Header, Label, Menu, MenuItem } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import AlertsTable from './TableContainer/AlertsTable';
import UpdatesTable from './TableContainer/UpdatesTable';
import '../../app/common/MediaQuery/responsive-alerts.css';
import UnauthorizedMessage from '../UnauthorizedMessage';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import EmailTable from './TableContainer/EmailTable';
 
function Message() {
  const [activeItem, setItemActiveItem] = useState<any>('');
  const [mailItem,setMailItem] = useState<{readMail:[],readMailCount:number,unReadMail:any[],unReadMailCount:number,isloading:boolean}>({
    readMail:[],readMailCount:0,unReadMail:[],unReadMailCount:0,isloading:false
  })
  const [pageNumber,setPageNumber] = useState<number>(0);
  const { rejectionStore } = useStore();
  const { loadRejections, rejectionRegistry, rejectionitemsByDate } =
    rejectionStore;
  const { dashboardStore, commonStore,EmailMessageStore } = useStore();
  useEffect(() => {
    if (commonStore.filterModeOne?.includes('SB01')) {
      setItemActiveItem('Alerts');
    } else if (commonStore.filterModeOne?.includes('SB02')) {
      setItemActiveItem('Messages');
    } else if (commonStore.filterModeOne?.includes('SB03')) {
      setItemActiveItem('Updates');
    } else {
      setItemActiveItem('');
    }
  }, [commonStore.filterModeOne]);
  useEffect(() => {
    if (rejectionRegistry.size <= 1) loadRejections();
  }, [rejectionRegistry.size, loadRejections]);
 
  const handleReadMail = () => {
    setPageNumber(1);
    setItemActiveItem('Read');
    setMailItem((prevMailItem) => ({
      ...prevMailItem,isloading:true
    }));
    EmailMessageStore.handleReadMail('',1).then((response: any) => {
      try {
        const [updatedReadMail, updatedReadMailCount] = response;
        setMailItem((prevMailItem) => ({
          ...prevMailItem,
          readMail: updatedReadMail,
          readMailCount: updatedReadMailCount,
          isloading:false
        }));
      } catch (error) {
        console.error('Error processing mail data:', error);
      }
    });
  };
 
  const handleUnreadMail = (Value:any) => {
    setPageNumber(1);
    setItemActiveItem('UnRead');
    setMailItem((prevMailItem) => ({
      ...prevMailItem,isloading:true
    }));
    EmailMessageStore.handleUnreadMail(Value,1).then((response: any) => {
      try {
        const [UpdateUnreadMail, UpdateUnreadMailCount] = response;
        setMailItem((prevMailItem) => ({
          ...prevMailItem,
          unReadMail: UpdateUnreadMail,
          unReadMailCount: UpdateUnreadMailCount,
          isloading:false
        }));
      } catch (error) {
        console.error('Error processing mail data:', error);
      }
    });
  };
  const handleEmailCount = async () => {
    try {
      const response = await EmailMessageStore.mailCountHandler('', true);
      const response2 = await EmailMessageStore.mailCountHandler('', false);
      setMailItem((prevMailItem) => ({
        ...prevMailItem,
        readMailCount: response,
        unReadMailCount: response2,
      }));
    } catch (error) {
      console.error("Error handling email count:", error);
      // Handle the error, show a message, or perform other error-handling actions
    }
  };
 
 
  const handleItemClick = (name: any) => setItemActiveItem(name);
  return (
    <>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <LoadingComponent />
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('DB03') && <UnauthorizedMessage />}
      {commonStore.filterModeOne.includes('DB03') && (
        <>
          <Header
            style={{ margin: '0px 0px 20px', paddingLeft: '20px' }}
            icon="chat"
            size="huge"
            dividing
            as="h1"
            content={
              (userLanguage[0].Messages?.SL01 as any)?.[
                `${commonStore.language.key}`
              ]
            } //'Messages'
            sub
            color="grey"
          />
          <Grid style={window.innerWidth < 1600 ?  { marginInline: '0px',flexDirection:'column'} : {marginInline: '0px'}} className='ddwewew'>
            <Grid.Column width={2}>
              {commonStore.filterModeTwo?.includes('SB01') &&
              commonStore.filterModeTwo?.includes('SB02') &&
              commonStore.filterModeTwo?.includes('SB03') ? (
                <></>
              ) : (
                <Menu vertical>
                  {!commonStore.filterModeTwo?.includes('SB01') && (
                    <MenuItem
                      name="Alerts"
                      active={activeItem === 'Alerts'}
                      onClick={() => handleItemClick('Alerts')}
                      disabled={commonStore.filterModeZero.includes('SB01')}
                      //Alerts
                    >
                      {' '}
                      <Label color="red">{rejectionitemsByDate.length}</Label>
                      {
                        (userLanguage[0].Messages?.SB01 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      }
                    </MenuItem>
                  )}
 
                  {commonStore.filterModeTwo?.includes('SB02') ? (
                    <></>
                  ) : (
                    <Dropdown text={
                      (userLanguage[0].Messages?.SB02 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }  item active={activeItem === 'Messages'} disabled={commonStore.filterModeZero.includes('SB02')} onClick={handleEmailCount}>
                    <DropdownMenu className="left">
                      <DropdownItem active={activeItem === 'Read'}>
                        <span className="text"  onClick={() => handleReadMail()} >{
                          (userLanguage[0].MessagesAlerts.SAB03 as any)?.[`${commonStore.language.key}`]
                          }  <Label color="blue" style={{ marginLeft: '30px' }}>
                           {mailItem.readMailCount}
                          </Label></span>
                      </DropdownItem>
                      <DropdownItem  active={activeItem === 'UnRead'}>
                        <span className="text" onClick={() => handleUnreadMail('')}> {
                          (userLanguage[0].MessagesAlerts.SAB04 as any)?.[`${commonStore.language.key}`]
                          } <Label color="blue" style={{ marginLeft: '15px' }}>
                           {mailItem.unReadMailCount}
                           </Label></span>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  )}
                  {commonStore.filterModeTwo?.includes('SB03') ? (
                    <></>
                  ) : (
                    <MenuItem
                      name="Updates"
                      active={activeItem === 'Updates'}
                      onClick={() => handleItemClick('Updates')}
                      disabled={commonStore.filterModeZero.includes('SB03')}
                      //Updates
                    >
                      <Label>1</Label>
                      {
                        (userLanguage[0].Messages?.SB03 as any)?.[
                          `${commonStore.language.key}`
                        ]
                      }
                    </MenuItem>
                  )}
                </Menu>
              )}
            </Grid.Column>
            <Grid.Column  width={13}>
              {activeItem === 'Alerts' ? (
                <AlertsTable />
              ) : activeItem === 'Updates' ? (
                <UpdatesTable />
              ) : activeItem === 'Read' ? (
                <EmailTable
                  tableDetails={mailItem.readMail}
                  tableName={'ReadMail'}
                  loading={mailItem.isloading}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  pageSize={mailItem.readMailCount}
                  setMailItem={setMailItem}
                  handleUnreadMail={handleUnreadMail}
                />
              ) : activeItem === 'UnRead' ? (
                <EmailTable
                  tableDetails={mailItem.unReadMail}
                  tableName={'UnreadMail'}
                  loading={mailItem.isloading}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  pageSize={mailItem.unReadMailCount}
                  setMailItem={setMailItem}
                  handleUnreadMail={handleUnreadMail}
                />
              ) : (
                <></>
              )}
            </Grid.Column>
          </Grid>
        </>
      )}
    </>
  );
}
 
export default observer(Message);